"use strict";
// functions sorted alphabetically
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotUndefined = exports.isObject = void 0;
exports.isEmpty = isEmpty;
exports.isNever = isNever;
function isEmpty(v) {
    return v === undefined
        || v === null
        || v === ''
        || (Array.isArray(v) && v.length === 0)
        || (typeof v === 'object' && Object.keys(v).length === 0);
}
const isObject = (value) => typeof value === "object" && !Array.isArray(value) && value !== null;
exports.isObject = isObject;
const isNotUndefined = (t) => t !== undefined;
exports.isNotUndefined = isNotUndefined;
// this function should never be called, useful for making sure checks are exhaustive
function isNever(p) {
    throw new Error('a never param has been produced 🤯');
}
//# sourceMappingURL=validation.js.map